var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"WuJieTemp"},[_c('WujieVue',{attrs:{"width":"100%","height":"100%","name":"WuJieTemp","url":_vm.url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }